<template lang="pug">
v-row
  v-col(cols="12" md="8")

    .text-body-1: strong Типовые договоры
    agreements-cards.mb-4(
      :agreements="agreements"
      @delete="deleteAgreement"
    )

    contract-documents

  v-col(cols="12" md="4")
    v-list-item.mx-n2.mb-4.sdo-radius.px-2(:to="{ name: 'CertificateEdit' }")
      v-list-item-icon.mr-4: v-icon(size="32" color="primary") mdi-certificate
      v-list-item-content.text-body-2: strong Редактор удостоверений
      v-list-item-action: v-icon(color="primary") mdi-arrow-right
    .d-flex
      .text-body-1: strong Мои реквизиты
      v-btn.ml-auto(
        fab x-small depressed
        color="primary"
        @click="openBankDetails"
      ): v-icon mdi-pencil
    v-skeleton-loader(
      v-if="loading"
      type="list-item@4"
    )
    v-list
      v-list-item.px-0.mb-2(
        v-for="(item, idx) in items"
        :key="idx"
      )
        v-list-item-content.py-1
          .caption.grey--text: strong {{item.name}}
          .text-body-2: strong {{ item.value }}

  portal(to="bankDetails.dialog" v-slot="{ close, attrs }")
    v-sheet.sdo-card
      v-card.fill-height.overflow-auto.scroll(max-height="600" flat)
        v-card-text
          bank-details

</template>

<script>
import { mapGetters } from 'vuex';
import BankDetails from '@/modules/PaymentSystem/components/BankDetails.vue';
import AgreementsCards from '@/modules/PaymentSystem/components/AgreementsCards.vue';
import ContractDocuments from '@/modules/PaymentSystem/components/ContractDocuments.vue';
// import Bureaucracy from '@/modules/PaymentSystem/components/Bureaucracy.vue';
import { CONTRACT_TYPES_NAMES } from '../constants';

export default {
  name: 'AgreementsSettings',
  components: {
    BankDetails,
    AgreementsCards,
    ContractDocuments,
  },
  props: {
    agreements: { type: Object, required: true },
  },
  data() {
    return {
      CONTRACT_TYPES_NAMES,
      tab: 0,
      loading: true,
      bankValues: {},
    };
  },
  computed: {
    ...mapGetters({ userOrganizations: 'auth/userOrganizations' }),
    items() {
      const { bankValues } = this;
      const values = {
        inn: 'ИНН',
        recipient_name: 'Наименование организации',
        legal_address: 'Юридический адрес',
        phone: 'Номер телефона',
        email: 'Почта',
        kpp: 'КПП',
        type: 'Тип счета',
        bic: 'БИК банка получателя',
        bank_name: this.bankValues?.type === 1 ? 'Банк' : 'Наименование УФК',
        ...bankValues.type === 2 ? { acc_personal: 'Лицевой счет' } : {},
        acc: 'Номер расчетного счета',
        ...bankValues.type === 1 ? {
          bank_cor_acc: 'Корреспондентский счет банка получателя',
          okpo: 'ОКПО',
        } : {
          eks: 'ЕКС',
          kbk: 'КБК',
          oktmo: 'ОКТМО',
        },

      };
      const types = { 1: 'Счет в кредитной организации (Банке)', 2: 'Счет в казначействе' };
      return bankValues.inn ? Object.entries(values).map(([key, name]) => ({
        name,
        value: key === 'type' ? types[this.bankValues.type] : (this.bankValues[key] || '-'),
      })) : [];
    },
  },
  watch: {
    tab(val) {
      this.$router.replace({ query: { ...this.$route.query, tab: val } });
    },
  },
  created() {
    this.getPayment();
  },

  methods: {
    openBankDetails() {
      this.$modals.show('dialog-portal', {
        inputValue: 'bankDetails',
        dialogProps: {
          width: 1000,
        },
      });
    },
    async getPayment() {
      const { id } = this.userOrganizations[0];
      const { data } = await this.$api.contracts.getPayment(id);
      this.bankValues = data.data?.payment_detail || {};
      this.loading = false;
    },
    deleteAgreement(agremeentKey) {
      this.$emit('delete', agremeentKey);
      // this.agreements[agremeentKey] = { ...agreements[agremeentKey] };
    },
  },
};
</script>

<style scoped>

</style>
